<template>
  <div>
    <div class="container">
      <b-container fluid id="add-school">
        <h1 class="title">Add School</h1>
        <div id="alerts">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added a school!</b-alert
          >
          <b-alert
            :show="showError"
            dismissible
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            variant="danger"
            >Something went wrong. Please ensure the school name, and location
            are entered.</b-alert
          >
        </div>
        <b-row class="mt-4">
          <b-col>
            <school-basic></school-basic>
            <hr>
            <group-trainer-search></group-trainer-search>
          </b-col>
          <b-col>
            <pupils-languages></pupils-languages>
          </b-col>
          <b-col>
            <geo-info
              singular="school"
              plural="schools"
              :coords="true"
            ></geo-info>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <br />
    <div class="container">
      <b-container fluid>
        <br />
        <confirm-submit></confirm-submit>
        <b-button
          :size="'lg'"
          :variant="'primary'"
          class="app_school_btn mb-4"
          :disabled="isDisabled"
          @click.prevent="createSchool"
          >Add School</b-button
        >
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SchoolBasic from '@/components/SchoolBasic';
import PupilsLanguages from '@/components/PupilsLanguages';
import GeoInfo from '@/components/GeoInfo';
import ConfirmSubmit from '@/components/ConfirmSubmit';
import { flash } from '../mixins/flashes';
import { scrollTo } from '../mixins/scrollTo';
import GroupTrainerSearch from '@/components/GroupTrainerSearch';

export default {
  name: 'NewSchool',
  mixins: [flash, scrollTo],
  components: {
    SchoolBasic,
    PupilsLanguages,
    GeoInfo,
    ConfirmSubmit,
    GroupTrainerSearch
  },
  data() {
    return {
      showError: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      isDisabled: false,
      allTeachers: [],
    };
  },
  methods: {
    ...mapActions({
      CREATE_SCHOOL: 'schools/CREATE_SCHOOL',
      RESET_SCHOOLS_STATE: 'schools/RESET_SCHOOLS_STATE',
    }),
    async createSchool() {
      if (!this.$store.state.confirmed) {
        alert('Please confirm the information above is correct');
        return;
      }
      if (!this.formError) {
        window.scrollTo(0, 0);
        this.flashError();
        return;
      }
      this.isDisabled = await true;
      await this.CREATE_SCHOOL();
      this.scrollTo(0, 0);
      await this.flashSuccess();
      await this.RESET_SCHOOLS_STATE();
      await this.$store.commit('resetConfirmed');
      this.isDisabled = await false;
      // setTimeout(() => this.$router.push({ name: 'SchoolsList' }), 1500);
    },
  },
  computed: {
    formError() {
      if (this.$store.state.schools.school.school_name.length <= 1) {
        return false;
      }
      if (this.$store.state.schools.school.country.length <= 1) {
        return false;
      }
      if (this.$store.state.schools.school.region.length <= 1) {
        return false;
      }
      if (this.$store.state.schools.school.district.length <= 1) {
        return false;
      }
      if (this.$store.state.schools.school.trainer.length <= 1) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.container {
  width: 90%;
  align-content: center;
}
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
  box-shadow: 3px 2px 2px #b2b2b2;
}
</style>
